import * as React from 'react';
import Helmet from 'react-helmet';

type Props = {
  children?: any;
  description?: string;
  image?: string;
  title?: string;
  twitterCard?: boolean;
};

export default function Head({
  children,
  description,
  image,
  title,
  twitterCard,
  ...others
}: Props) {
  return (
    <Helmet {...others} titleTemplate={title ? `%s | Remind` : undefined}>
      {title && <title>{title}</title>}
      {title && <meta name="twitter:title" property="og:title" content={title} />}
      {description && <meta name="description" property="og:description" content={description} />}
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" property="og:image" content={image} />}
      {twitterCard && <meta name="twitter:card" content="summary_large_image" />}
      {twitterCard && <meta name="twitter:site" content="@RemindHQ" />}
      {children}
    </Helmet>
  );
}
